import app from "./config";

let authPromise;
let firestorePromise;
let storagePromise;
let functionsPromise;

const waitForWindowLoad = async () => {
  if (typeof document === "undefined") return;
  if (document.readyState === "complete") return;
  await new Promise((resolve) => {
    window.addEventListener("load", resolve, { once: true });
  });
};

export const getAuthService = async () => {
  if (!authPromise) {
    authPromise = (async () => {
      await waitForWindowLoad();
      const { getAuth } = await import("firebase/auth");
      return getAuth(app);
    })();
  }
  return authPromise;
};

export const getFirestoreService = async () => {
  if (!firestorePromise) {
    firestorePromise = (async () => {
      const { initializeFirestore } = await import("firebase/firestore");
      return initializeFirestore(app, {
        experimentalForceLongPolling: true,
      });
    })();
  }
  return firestorePromise;
};

export const getStorageService = async () => {
  if (!storagePromise) {
    storagePromise = (async () => {
      const { getStorage } = await import("firebase/storage");
      return getStorage(app);
    })();
  }
  return storagePromise;
};

export const getFunctionsService = async () => {
  if (!functionsPromise) {
    functionsPromise = (async () => {
      const { getFunctions } = await import("firebase/functions");
      const functionsRegion = import.meta.env.VITE_FIREBASE_FUNCTIONS_REGION;
      return functionsRegion
        ? getFunctions(app, functionsRegion)
        : getFunctions(app);
    })();
  }
  return functionsPromise;
};
